export const ActionTypes = {
    GET_INVENTORY_STATUS_NFC: 'GET_INVENTORY_STATUS_NFC',
    GET_INVENTORY_STATUS_CLOSED: 'GET_INVENTORY_STATUS_CLOSED',
    GET_INVENTORY_STATUS_REASONS: 'GET_INVENTORY_STATUS_REASONS',
    GET_INVENTORY_STATUS_PERCENTAGES: 'GET_INVENTORY_STATUS_PERCENTAGES',
    GET_INVENTORY_STATUS_COMPLETE: 'GET_INVENTORY_STATUS_COMPLETE',
    GET_INVENTORY_STATUS_INCOMPLETE: 'GET_INVENTORY_STATUS_INCOMPLETE',
    GET_INVENTORY_STATUS_SYNC: 'GET_INVENTORY_STATUS_SYNC',
    CLOSE_INVENTORY_STATUS: 'CLOSE_INVENTORY_STATUS',
    CREATE_INVENTORY_STATUS: 'CREATE_INVENTORY_STATUS',
    EDIT_INVENTORY_STATUS: 'EDIT_INVENTORY_STATUS',
    DELETE_INVENTORY_STATUS: 'DELETE_INVENTORY_STATUS',
    SET_INVENTORY_STATUS_FILTERS: 'SET_INVENTORY_STATUS_FILTERS',
    CLEAR_INVENTORY_STATUS: 'CLEAR_INVENTORY_STATUS',
};